import { createSlice } from "@reduxjs/toolkit";
import { getExercise } from "../../api/APIServices";
import { API_STATUS } from "../../constants";

const initialState = {status:API_STATUS.IDEL, exerciseData:[]};
const exerciseSlice = createSlice({
    name:'exercise',
    initialState,
    reducers:{ },
    extraReducers:(builder)=>{
        builder.addCase(getExercise.fulfilled, (state, action)=>{
            state.exerciseData = action.payload;
            state.status = API_STATUS.IDEL;
        }),
        builder.addCase(getExercise.pending, (state)=>{
            state.status = API_STATUS.PENDING;
        }),
        builder.addCase(getExercise.rejected, (state)=>{
            state.status = API_STATUS.ERROR;
        })
    }
});

export const {} = exerciseSlice.actions;
export default exerciseSlice.reducer;